import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ConnectivityService } from './services';
import { NetworkBackdropComponent } from './components/network-backdrop/network-backdrop.component';
import { IonicModule } from '@ionic/angular';
import { ConnectivityStateModule } from './+state/connectivity.state.module';

@NgModule({
  imports: [CommonModule, IonicModule, ConnectivityStateModule],
  declarations: [NetworkBackdropComponent],
  exports: [NetworkBackdropComponent],
})
export class NetworkConnectivityModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NetworkConnectivityModule,
      providers: [ConnectivityService],
    };
  }
}
